import React from "react";
import Logo from "./Logo";
import { useTheme } from "@shared/components/common/theme-provider";
import { Button } from "@shared/components/ui/button";
import { Moon, Sun, Laptop } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@shared/components/ui/dropdown-menu";
import UserProfileMenu from "./UserProfileMenu";
import SyncButton from "./SyncButton";

interface BaseNavProps {
  leftActions?: React.ReactNode;
}

export default function BaseNav({ leftActions }: BaseNavProps) {
  const { setTheme } = useTheme();

  return (
    <div className="fixed top-0 left-0 right-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center px-4 md:px-6">
        {/* Left: Logo and App Name */}
        <div className="flex items-center gap-2">
          <Logo />
          {leftActions && <div className="ml-4 flex gap-2">{leftActions}</div>}
        </div>
        {/* Right: Sync/Theme/Profile */}
        <div className="ml-auto flex items-center gap-2">
          {/* Sync status + control (hidden when everything is in sync) */}
          <SyncButton />
          {/* Theme Toggle */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon">
                <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
                <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
                <span className="sr-only">Toggle theme</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => setTheme("light")}> <Sun className="mr-2 h-4 w-4" /> <span>Light</span> </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setTheme("dark")}> <Moon className="mr-2 h-4 w-4" /> <span>Dark</span> </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setTheme("system")}> <Laptop className="mr-2 h-4 w-4" /> <span>System</span> </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          {/* User Profile Menu */}
          <UserProfileMenu />
        </div>
      </div>
    </div>
  );
} 